import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface LogisticsCostProps {}

const LogisticsCost: FC<LogisticsCostProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'logisticsCost'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} min={0} />
        </Form.Item>
    )
}

export default LogisticsCost
